/*
 * @Author: wangcq01
 * @LastEditors: wangcq01
 * @Date: 2019-10-23 11:18:49
 * @LastEditTime: 2019-12-02 10:35:00
 * @FilePath: \dmp-web-v2\chartlibs\terminal_mobile\common\f2\components\base\processor\setDataConfig.js
 * @Description: 模块
 */
import cloneDeep from 'lodash/cloneDeep'
import isEmpty from 'lodash/isEmpty'
import pickBy from 'lodash/pickBy'
import isObject from 'lodash/isObject'
import has from 'lodash/has'

export const process = (chart, config) => {
  const cDefs = cloneDeep(config.defs)
  const isArr = Array.isArray(cDefs)

  const options = {}
  if (!isEmpty(cDefs)) {
    const arrDefs = isArr ? cDefs : [cDefs]

    arrDefs.forEach((res) => {
      if (res.dataKey) {
        const { dataKey, ...currOption } = res
        options[res.dataKey] = currOption
      }
    })
  }
  
  if (isEmpty(config.data)) {
    config.data = []
  }
  
  if (!isEmpty(config.series)) {
    const cData = cloneDeep(config.data)
    const arrData = Array.isArray(cData) ? cData : [cData]
    
    // chart.source(arrData, options) 这里对options的处理应和传入值相同, 暂时采用标志位判断
    if (has(cDefs, 'flag')) {
      chart.source(arrData, pickBy(cDefs, isObject))
    } else {
      chart.source(arrData, options)
    }
  }
}
